import { Color, type ColorRepresentation, type ShaderMaterial } from 'three';

/** Drei's grid material seeds these mutable values from shared class defaults. */
export function isolateGridUniforms(
  material: ShaderMaterial,
  cellColor: ColorRepresentation,
  sectionColor: ColorRepresentation,
) {
  const { uniforms } = material;
  // Restore this grid's requested colors as well: two grids may mount in the
  // same commit, applying both sets of props before either layout effect runs.
  uniforms.cellColor.value = new Color(cellColor);
  uniforms.sectionColor.value = new Color(sectionColor);
  uniforms.worldCamProjPosition.value =
    uniforms.worldCamProjPosition.value.clone();
  uniforms.worldPlanePosition.value = uniforms.worldPlanePosition.value.clone();
}
